import { render, staticRenderFns } from "./CreateNewVendorEntryDialog.vue?vue&type=template&id=2f8fa7a3&scoped=true"
import script from "./CreateNewVendorEntryDialog.vue?vue&type=script&lang=ts"
export * from "./CreateNewVendorEntryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fa7a3",
  null
  
)

export default component.exports